export default __webpack_public_path__ + "static/media/saibaba-newburgh1-modified.d1deddea.png";